import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Success from '../views/success.vue'
import Joinus from '../views/joinus.vue'
//import Zixun from '../views/zixun.vue'
import Hospital from '../views/hospital/hospital.vue'
import case01 from '../views/hospital/case/case1.vue'
import case02 from '../views/hospital/case/case2.vue'
import case03 from '../views/hospital/case/case3.vue'
import case04 from '../views/hospital/case/case4.vue'
import case05 from '../views/hospital/case/case5.vue'
import case06 from '../views/hospital/case/case6.vue'
import case07 from '../views/hospital/case/case7.vue'
import case08 from '../views/hospital/case/case8.vue'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
//replace
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    component: Index,
    redirect: '/home',
    children: [
      { path: '/home', name: 'home1', component: Home },
      { path: '/success', name: 'success', component: Success },
      { path: '/about', name: 'about', component: About },
      { path: '/joinus', component: Joinus },
      { path: '/zixun', name: 'home2', component: Home },
      {
        //医疗解决方案
        path: '/hospital',
        component: Hospital,
        redirect: '/hospital/case05',
        children: [
          { path: '/hospital/case01', component: case01 },
          { path: '/hospital/case02', component: case02 },
          { path: '/hospital/case03', component: case03 },
          { path: '/hospital/case04', component: case04 },
          { path: '/hospital/case05', component: case05 },
          { path: '/hospital/case06', component: case06 },
          { path: '/hospital/case07', component: case07 },
          { path: '/hospital/case08', component: case08 }
        ]
      },
      {
        //电信解决方案
        path: '/chinatele',
        //component: Chinatele,
        component: () => import('../views/chinatele/chinatele.vue'),
        redirect: '/chinatele/case01',
        children: [
          { path: '/chinatele/case01', component: () => import('../views/chinatele/case/case1.vue') },
          { path: '/chinatele/case02', component: () => import('../views/chinatele/case/case2.vue') },
          { path: '/chinatele/case03', component: () => import('../views/chinatele/case/case3.vue') },
          { path: '/chinatele/case04', component: () => import('../views/chinatele/case/case4.vue') },
          { path: '/chinatele/case05', component: () => import('../views/chinatele/case/case5.vue') },
          { path: '/chinatele/case06', component: () => import('../views/chinatele/case/case6.vue') },
          { path: '/chinatele/case07', component: () => import('../views/chinatele/case/case7.vue') },
          { path: '/chinatele/case08', component: () => import('../views/chinatele/case/case8.vue') },
          { path: '/chinatele/case09', component: () => import('../views/chinatele/case/case9.vue') }
        ]
      },
      {
        //Ai 智慧监管
        path: '/AI',
        component: () => import('../views/AI/AIindex.vue'),
        redirect: '/AI/case01',
        children: [
          { path: '/AI/case01', component: () => import('../views/AI/case/case1.vue') },
          { path: '/AI/case02', component: () => import('../views/AI/case/case2.vue') }
        ]
      },
      {
        //安全产品
        path: '/anquan',
        component: () => import('../views/anquan/anquan.vue'),
        redirect: '/anquan/case01',
        children: [
          { path: '/anquan/case01', component: () => import('../views/anquan/case/case1.vue') },
          { path: '/anquan/case02', component: () => import('../views/anquan/case/case2.vue') },
          { path: '/anquan/case03', component: () => import('../views/anquan/case/case3.vue') }
        ]
      },
      {
        //新闻咨询
        path: '/news',
        component: () => import('../views/news/newsindex.vue'),
        redirect: '/news/case01',
        children: [
          { path: '/news/case01', component: () => import('../views/news/case/case1.vue') },
          { path: '/news/case02', component: () => import('../views/news/case/case2.vue') },
          { path: '/news/case03', component: () => import('../views/news/case/case3.vue') }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_Route,
  //scrollBehavior: () => ({ y: 0 }),
  routes
})

// const createRouter = () =>
//   new VueRouter({
//     mode: 'history',
//     scrollBehavior: () => ({ y: 0 }),
//     routes: routes
//   })

export default router
